import React, { Component } from "react";
import VideoComponent from "../components/VideoComponent";
import TurnDeviceDialog from "../components/TurnDeviceDialog";
import {isMobile,osName,isChrome,isMobileSafari,isSafari,isIOS} from 'react-device-detect';
import { connect } from "react-redux";
import * as actions from "../actions";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown
} from "@fortawesome/fontawesome-free-solid";
class Capture extends Component {
  constructor(props){
    super(props);
    this.state = {
      orientation: "landscape",
      isHelloBar: true,
    }

    this.checkDeviceFormat = this.checkDeviceFormat.bind(this);
  }
  componentDidMount() {
    this.checkDeviceFormat();
    window.addEventListener("resize", this.checkDeviceFormat);
  }

  checkDeviceFormat() {
    if(window.innerHeight > window.innerWidth){
      this.setState({ orientation: "portrait"})
    }else{
      this.setState({ orientation: "landscape"})
    }
  }
  
  render() {
    return (
      <div>
        {(isMobile && isIOS) ? (
            <div className="hello-bar-wrapper">
                <div className={"hello-bar"  + (!this.state.isHelloBar ? ' closed' : '')}>
                    <span>This site works best on Android Chrome, and doesn't work on iOS.<br/><a href="https://caniuse.com/#feat=pointer">See why</a></span>
                </div>
            </div>
        ) : (
            <div>
                {(isMobile && !isChrome) ? (
                    <div className="hello-bar-wrapper">
                        <div className={"hello-bar android"  + (!this.state.isHelloBar ? ' closed' : '')}>
                            <span>If the camera doesn't work, try using Android Chrome.<br/><a href="googlechrome://navigate?url=https://tuckandrose.family/capture">Click here</a></span>
                            <div className="close-hello-bar" onClick={ () => this.setState({ isHelloBar: !this.state.isHelloBar}) }><FontAwesomeIcon icon={faArrowUp}/></div>
                        </div>
                        <div className={"open-hello-bar"  + (!this.state.isHelloBar ? ' open' : '')} onClick={ () => this.setState({ isHelloBar: !this.state.isHelloBar}) }><FontAwesomeIcon icon={faArrowDown} /></div>
                    </div>
                ) : ''}
                <div>
                    {this.state.orientation === "landscape" ? (
                        <div>
                            <VideoComponent
                            sendDrawing={this.props.sendDrawing}
                            reinitUpStatus={this.props.reInitUploadStatus}
                            uploadStatus={this.props.drawnImage.uploadStatus}
                            />
                        </div>
                    ): <TurnDeviceDialog/>
                    }
                </div>
            </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    drawnImage: state.drawnImage
  };
}
export default connect(mapStateToProps, actions)(Capture);



// WEBPACK FOOTER //
// ./src/containers/Capture.js